import {writable} from 'svelte/store';

const initState = {
    map: null,
    mapLocation: undefined,

    planPois: [],

    selectedFilters: {}
};

function PoiStore(state = initState) {
    const {
        subscribe,
        // set,
        update
    } = writable(
        state
    );

    function updateState(data) {
        Object.entries(data)
            .forEach(([dataName, newData]) => {
                update((storeState) => {
                    storeState[dataName] = newData;

                    return storeState;
                });
            });
    }

    return {
        subscribe,
        get state() {
            return state;
        },
        get map() {
            return state.map;
        },
        set map(map) {
            updateState({map});
        },
        get mapLocation() {
            return state.mapLocation;
        },
        set mapLocation(mapLocation) {
            updateState({mapLocation});
        },
        get planPois() {
            return state.planPois;
        },
        set planPois(planPois) {
            updateState({planPois});
        },
        get availableFilters() {
            return state.availableFilters;
        },
        set availableFilters(availableFilters) {
            updateState({availableFilters});
        },
        get selectedFilters() {
            return state.selectedFilters;
        },
        set selectedFilters(selectedFilters) {
            updateState({selectedFilters});
        }
    };
}

export const poiStore = PoiStore();
